import { useQuery } from '@tanstack/react-query';

import { getCurrencyFormatController } from '@/interface-adapters/controllers/lookups/get-currency.controller';
import { getCurrenciesController } from '@/interface-adapters/controllers/lookups/get-currencies.controller';

export const useCurrencyQuery = (currencyId?: string) => {
	return useQuery({
		queryKey: ['CURRENCIES', currencyId],
		queryFn: () => getCurrencyFormatController(currencyId!),
		enabled: Boolean(currencyId)
	});
};

export const useCurrenciesQuery = (isEnabled: boolean = false) => {
	return useQuery({
		queryKey: ['ALL_CURRENCIES'],
		queryFn: () => getCurrenciesController(),
		enabled: isEnabled
	});
};
